/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Trans } from "react-i18next";

class Footer extends Component {
  renderLink = (name, path, icon) => {
    if (!this.props.navigation?.find((n) => n.name === path)) return null;
    return (
      <li>
        <Link to={path}>{name}</Link>
      </li>
    );
  };

  render = () => {
    if (this.props.navigation?.length === 0) return null;
    return (
      <footer className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center my-3 bottomLogoArea">
              <img
                src="/img/ford-logo.png"
                className="img-fluid"
                alt="Ford Logo"
              />
              <img
                src="/img/ford-truck-logo.png"
                className="img-fluid ml-3"
                alt="Ford Truck Logo"
              />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 text-center copyright">
              <Trans desc="Ford Otosan. Her hakkı saklıdır">10380</Trans>
              {/* <span className="seperator">|</span> */}
              <div className="contactOpt">
                {/* <a href="tel:000" className="footer-link">
                000
              </a> */}
                <span className="seperator">|</span>
                {/* <span className="icon-icon-mail"></span> */}
                <a href="mailto:destek@fordders.com" className="footer-link">
                  destek@fordders.com
                </a>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-1 col-lg-1 design">
              <a href="https://genbil.com">
                <img
                  src="/img/genbil-logo.png"
                  className="img-fluid"
                  alt="GENBİL Logo"
                />
              </a>
            </div>
          </div>
        </div>
      </footer>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    navigation: state.profile.general.navigations,
  };
};

export default connect(mapStateToProps, null)(withRouter(Footer));
